import { create } from 'zustand';

interface PledgeStudyTabStore {
  createOpen: boolean;
  addMPModalFor: 'create' | 'edit' | null;
  setCreateOpen: (open: boolean) => void;
  setAddMPModalFor: (mode: 'create' | 'edit' | null) => void;
  reset: () => void;
}

export const usePledgeStudyTabStore = create<PledgeStudyTabStore>((set) => ({
  createOpen: false,
  addMPModalFor: null,
  setCreateOpen: (open) => set({ createOpen: open }),
  setAddMPModalFor: (mode) => set({ addMPModalFor: mode }),
  reset: () => set({ createOpen: false, addMPModalFor: null }),
}));
